import { isAndroid, isIOS } from 'mobile-device-detect';

export function redirectToAppstore(){
    if(isIOS){
        window.location = "https://itunes.apple.com/hk/app/hyperair-%E5%94%B1%E9%8C%A2%E7%A5%9E%E5%99%A8-%E5%A4%96%E5%B9%A3%E9%A0%90%E8%A8%82-%E6%97%85%E9%81%8Asim%E5%8D%A1/id1397364347?mt=8";
    }else if(isAndroid){
        window.location = "https://play.google.com/store/apps/details?id=com.hyperair.app";
    }
}
